<template>
  <div class="control-buttons">
    <button
      :class="{
        'control-buttons__list': !showSidebar,
        'control-buttons__list control-buttons__list_active': showSidebar,
      }"
      @click="showSidebar = true"
      @touchmove="handleTouchMove"
    >
      <div class="control-buttons__content">
        <svg
          width="24"
          height="20"
          viewBox="0 0 24 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.32787 17.8431C4.32787 19.0343 3.35904 20 2.16393 20C0.968826 20 0 19.0343 0 17.8431C0 16.6519 0.968826 15.6863 2.16393 15.6863C3.35904 15.6863 4.32787 16.6519 4.32787 17.8431Z"
            class="svg-icon"
          />
          <path
            d="M5.90164 17.8431C5.90164 16.6519 6.87047 15.6863 8.06557 15.6863H21.8361C23.0312 15.6863 24 16.6519 24 17.8431C24 19.0343 23.0312 20 21.8361 20H8.06557C6.87047 20 5.90164 19.0343 5.90164 17.8431Z"
            class="svg-icon"
          />
          <path
            d="M4.32787 10C4.32787 11.1912 3.35904 12.1569 2.16393 12.1569C0.968826 12.1569 0 11.1912 0 10C0 8.8088 0.968826 7.84314 2.16393 7.84314C3.35904 7.84314 4.32787 8.8088 4.32787 10Z"
            class="svg-icon"
          />
          <path
            d="M5.90164 10C5.90164 8.8088 6.87047 7.84314 8.06557 7.84314H21.8361C23.0312 7.84314 24 8.8088 24 10C24 11.1912 23.0312 12.1569 21.8361 12.1569H8.06557C6.87047 12.1569 5.90164 11.1912 5.90164 10Z"
            class="svg-icon"
          />
          <path
            d="M4.32787 2.15686C4.32787 3.34807 3.35904 4.31373 2.16393 4.31373C0.968826 4.31373 0 3.34807 0 2.15686C0 0.96566 0.968826 0 2.16393 0C3.35904 0 4.32787 0.96566 4.32787 2.15686Z"
            class="svg-icon"
          />
          <path
            d="M5.90164 2.15686C5.90164 0.96566 6.87047 0 8.06557 0H21.8361C23.0312 0 24 0.96566 24 2.15686C24 3.34807 23.0312 4.31373 21.8361 4.31373H8.06557C6.87047 4.31373 5.90164 3.34807 5.90164 2.15686Z"
            class="svg-icon"
          />
        </svg>
        <span>Список</span>
      </div>
    </button>
    <button
      :class="{
        'control-buttons__map': showSidebar,
        'control-buttons__map control-buttons__map_active': !showSidebar,
      }"
      @click="showSidebar = false"
    >
      <div class="control-buttons__content">
        <svg
          width="14"
          height="20"
          viewBox="0 0 14 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 0C12 0 14 4.0048 14 7.71141C14 11.418 7 20 7 20C7 20 0 11.418 0 7.71141C0 4.0048 2 0 7 0ZM7.07 5.02685C5.7169 5.02685 4.62 6.07853 4.62 7.37584C4.62 8.67315 5.7169 9.72483 7.07 9.72483C8.4231 9.72483 9.52 8.67315 9.52 7.37584C9.52 6.07853 8.4231 5.02685 7.07 5.02685Z"
            fill="#FF0020"
            class="svg-icon"
          />
        </svg>
        <span>На карте</span>
      </div>
    </button>
  </div>
  <div class="custom-map-container">
    <button
      class="custom-map-toggle-button"
      @click="showSidebar = !showSidebar"
    >
      <svg
        v-if="!showSidebar"
        class="toggle-icon"
        width="26"
        height="34"
        viewBox="0 0 26 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="26"
          y="34"
          width="26"
          height="34"
          rx="4"
          transform="rotate(180 26 34)"
          fill="#FF0020"
        />
        <path
          d="M18.5708 16.1423C19.2182 16.5307 19.2182 17.4689 18.5708 17.8573L9.5145 23.2911C8.84797 23.691 8 23.2109 8 22.4336L8 11.566C8 10.7887 8.84797 10.3086 9.5145 10.7085L18.5708 16.1423Z"
          fill="white"
        />
      </svg>

      <svg
        v-if="showSidebar"
        class="toggle-icon"
        width="26"
        height="34"
        viewBox="0 0 26 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="26" height="34" rx="4" fill="#FF0020" />
        <path
          d="M7.42915 17.8577C6.78181 17.4693 6.78182 16.5311 7.42915 16.1427L16.4855 10.7089C17.152 10.309 18 10.7891 18 11.5664L18 22.434C18 23.2113 17.152 23.6914 16.4855 23.2915L7.42915 17.8577Z"
          fill="white"
        />
      </svg>
    </button>

    <span class="toggle-message">{{
      showSidebar ? "Свернуть" : "Развернуть"
    }}</span>

    <div class="custom-map-sidebar-header">
      <h3 class="custom-map-sidebar-header__title">
        Адреса жилых комплексов Основы
      </h3>
    </div>

    <div class="custom-map-sidebar" :class="{ 'is-visible': showSidebar }">
      <div v-if="showSidebar" class="mobile-sidebar-header">
        <h3 class="mobile-sidebar-header__title">
          Адреса жилых комплексов Основы
        </h3>
      </div>
      <div class="custom-map-sidebar__list">
        <div
          v-for="office in offices"
          :key="office.id"
          class="custom-map-sidebar__item"
          :class="{ 'is-active': activeOffice === office.id }"
          @click="handleOfficeClick(office)"
        >
          <div class="office-card">
            <h4 class="office-card__title">{{ office.name }}</h4>
            <p class="office-card__address">{{ office.address }}</p>
            <p class="office-card__phone" v-if="captchaStore.state.captchaVerified">
              <a
                :href="'tel:' + $filters.phoneFormat(getPhoneForOffice(office))"
                :class="getPhoneClass(office)"
              >
                {{ getPhoneForOffice(office) }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-map-main">
      <div
        class="custom-map-wrapper"
        @wheel.passive.capture="wheelHandler"
        @mousedown.passive="overlay = false"
        @touchstart.passive="touchHandler"
      >
        <yandex-map
          v-model="map"
          :settings="{
            location: mapLocation,
          }"
          width="100%"
          height="100%"
        >
          <yandex-map-default-scheme-layer />
          <yandex-map-default-features-layer />

          <yandex-map-marker
            v-for="(office, index) in offices"
            :key="`office-${index}`"
            :settings="{
              coordinates: office.coordinates,
              properties: {
                hintContent: office.name,
                balloonContent: office.address,
              },
              zIndex:
                activeOffice === office.id || hoveredOffice === office.id
                  ? 1000
                  : 1,
            }"
          >
            <div
              class="office-marker"
              :class="{
                'office-marker--hover':
                  hoveredOffice === office.id || activeOffice === office.id,
                'office-marker--mobile': isMobile,
              }"
              @mouseenter="hoveredOffice = office.id"
              @mouseleave="hoveredOffice = null"
              @click="handleMarkerClick(office)"
            >
              <div
                v-if="
                  hoveredOffice === office.id ||
                  activeOffice === office.id ||
                  (isMobile && clickedMarker === office.id)
                "
                class="office-marker__title"
              >
                <p>{{ office.name }}</p>
              </div>
              <div class="office-marker__image">
                <img :src="office.marker_image" :alt="office.name" />
              </div>
            </div>
          </yandex-map-marker>

          <yandex-map-controls :settings="{ position: 'right' }">
            <ZoomControls />
          </yandex-map-controls>
        </yandex-map>
        <div
          class="map-overlay"
          :class="{
            'with-sidebar': showSidebar,
            'is-active': overlay,
            'is-touch-active': isMapTouchActive,
          }"
        >
          <p class="map-overlay__text">
            Чтобы изменить масштаб, <br />
            прокручивайте карту <br />
            удерживая CTRL
          </p>
          <p class="map-overlay__text map-overlay__text_mobile">
            Чтобы активировать карту,
            <br />
            нажмите кнопку ниже
            <br />
          </p>
          <div class="particle"></div>
        </div>
        <button
          class="btn btn-default btn-small"
          @click.stop="mobileTouchActivate"
        >
          {{
            !isMapTouchActive ? "Активировать карту" : "Деактивировать карту"
          }}
        </button>
        <div class="map-shade"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapMarker,
  YandexMapControls,
} from "vue-yandex-maps";
import { ref, computed, shallowRef, nextTick } from "vue";
import ZoomControls from "@/components/home/ZoomControls.vue";

import emotion from "@i/zk-render/emotion.png";
import sokolinaya from "@i/zk-render/sokolinaya-gora.png";
import mirapolis from "@i/zk-render/mirapolis.png";
import sokolniki from "@i/zk-render/evo-sokolniki.png";
import izmaylovo from "@i/zk-render/evo-izmaylovo.png";
import gorbunova from "@i/zk-render/gorbunova.png";
import nametkin from "@i/zk-render/nametkin-tower.png";
import very from "@i/zk-render/very-botsad.png";
import fizteh from "@i/zk-render/fizteh.png";
import red from "@i/zk-render/red-7.png";
import golovinskie from "@i/zk-render/golovinskie.png";
import mainstreet from "@i/zk-render/mainstreet.png";
import veryMik from "@i/zk-render/very-mik.png";
import gogol from "@i/zk-render/gogol-park.png";
import malinovo from "@i/zk-render/malinovo.png";

export default {
  components: {
    YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapMarker,
    YandexMapControls,
    ZoomControls,
  },
  inject: ["captchaStore"],
  setup() {
    const map = shallowRef(null);
    const showSidebar = ref(false);
    const activeOffice = ref(null);
    const hoveredOffice = ref(null);
    const tabs = ref(null);
    const overlay = ref(false);
    const clickedMarker = ref(null);
    const isMobile = ref(window.innerWidth < 768);
    let timeout = null;
    const isMapTouchActive = ref(false);

    const getPhoneClass = (office) => {
      const specialPhones = {
        "+7 (495) 021-00-09": ["PlanCommerceSearch", "CommerceFlat"],
      };

      for (const phone in specialPhones) {
        if (specialPhones[phone].includes(office.id)) {
          return "";
        }
      }
      return "comagic_phone";
    };

    const getPhoneForOffice = (office) => {
      return office.phone;
    };

    const offices = ref([
      {
        id: 1,
        name: "EMOTION",
        address: "Москва, 2-й Силикатный проезд, вл. 8",
        phone: "+7 (495) 489-78-82",
        coordinates: [37.50841, 55.768764],
        link: "https://gk-osnova.ru/emotion",
        marker_image: emotion,
      },
      {
        id: 2,
        name: "UNO.Соколиная гора",
        address: "г. Москва, 8-я ул. Соколиной горы, вл. 26А",
        phone: "+7 (495) 989-48-36",
        coordinates: [37.741469, 55.768945],
        link: "https://gk-osnova.ru/sokolinaya-gora",
        marker_image: sokolinaya,
      },
      {
        id: 3,
        name: "МИРАПОЛИС",
        address: "г. Москва, Проспект мира, 222",
        phone: "+7 (495) 989-48-36",
        coordinates: [37.666401, 55.841805],
        link: "https://gk-osnova.ru/mirapolis",
        marker_image: mirapolis,
      },
      {
        id: 4,
        name: "EVOPARK Сокольники",
        address: "г. Москва, ул. Потешная, вл. 5, стр. 1,2",
        phone: "+7 (495) 989-11-47",
        coordinates: [37.700576, 55.801274],
        link: "https://gk-osnova.ru/evosokolniki",
        marker_image: sokolniki,
      },
      {
        id: 5,
        name: "EVOPARK Измайлово",
        address: "г. Москва, ул. Электродная, вл. 2А.",
        phone: "+7 (495) 989-48-36",
        coordinates: [37.750336, 55.755782],
        link: "https://gk-osnova.ru/evoizmaylovo",
        marker_image: izmaylovo,
      },
      {
        id: 6,
        name: "UNO.Горбунова",
        address: "г. Москва, ул. Горбунова, вл. 27",
        phone: "+7 (495) 181-52-96",
        coordinates: [37.384253, 55.722431],
        link: "https://gk-osnova.ru/gorbunova",
        marker_image: gorbunova,
      },
      {
        id: 7,
        name: "NAMETKIN TOWER",
        address: "г. Москва, ул. Намёткина, 10",
        phone: "+7 (495) 104-92-29",
        coordinates: [37.553195, 55.66185],
        link: "https://gk-osnova.ru/nametkin-tower",
        marker_image: nametkin,
      },
      {
        id: 8,
        name: "VERY на Ботанической",
        address: "г. Москва, Ботаническая 29, корп 2, стр 6",
        phone: "+7 495 324-61-75",
        coordinates: [37.593605, 55.833031],
        link: "https://gk-osnova.ru/very-botsad",
        marker_image: very,
      },
      {
        id: 9,
        name: "ФИЗТЕХСИТИ",
        address: "г. Москва, ул. Новодачная, 67/68",
        phone: "8 (495) 021-52-02",
        coordinates: [37.533763, 55.922885],
        link: "https://gk-osnova.ru/fizteh",
        marker_image: fizteh,
      },
      {
        id: 10,
        name: "RED7",
        address:
          "г. Москва, ЦАО, Красносельский район, просп. Академика Сахарова, 7",
        phone: "+7 (495) 320-77-17",
        coordinates: [37.64335, 55.77115],
        link: "https://gk-osnova.ru/red-7",
        marker_image: red,
      },
      {
        id: 11,
        name: "UNO.ГОЛОВИНСКИЕ ПРУДЫ",
        address: "г. Москва, Михалковская ул., 50",
        phone: "+7 (495) 431-10-58",
        coordinates: [37.518856, 55.835897],
        link: "https://gk-osnova.ru/golovinskie-prudy",
        marker_image: golovinskie,
      },
      {
        id: 12,
        name: "MAINSTREET",
        address: "г. Москва, ул. Ивана Франко, 6",
        phone: "+7 (495) 181-52-96",
        coordinates: [37.450917, 55.728181],
        link: "https://gk-osnova.ru/zk-mainstreet",
        marker_image: mainstreet,
      },
      {
        id: 13,
        name: "VERY на Миклухо-Маклая",
        address: "Москва, Миклухо-Маклая, 23",
        phone: "+7 (495) 104-92-29",
        coordinates: [37.511761, 55.65062],
        link: "https://gk-osnova.ru/mikluho-maklaya",
        marker_image: veryMik,
      },
      {
        id: 14,
        name: "ГОГОЛЬ ПАРК",
        address: "МО, г. Люберцы, ул. Гоголя, 3",
        phone: "+7(495) 432-12-26",
        coordinates: [37.900345, 55.704551],
        link: "https://gk-osnova.ru/gogolpark",
        marker_image: gogol,
      },
      {
        id: 15,
        name: "ЖК МАЛИНОВО",
        address: "МО, Одинцово ГО, г. Звенигород, мкрн. Восточный",
        phone: "+7 (495) 085-43-53",
        coordinates: [36.872561, 55.725678],
        link: "https://gk-osnova.ru/malinovo",
        marker_image: malinovo,
      },
    ]);

    const mapLocation = computed(() => ({
      center: offices.value[18]?.coordinates || [37.640084, 55.750531],
      zoom: 11,
    }));

    const handleOfficeClick = (office) => {
      hoveredOffice.value = null;
      activeOffice.value = office.id;
      clickedMarker.value = office.id;

      if (map.value && office.coordinates) {
        map.value.setLocation({
          center: office.coordinates,
          duration: 400,
          zoom: 14,
        });
      }

      if (showSidebar.value) {
        nextTick(() => {
          const element = document.querySelector(
            `.custom-map-sidebar__item.is-active`
          );
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          }
        });
      }
    };

    const handleTouchMove = (e) => {
      const isScrollable =
        e.currentTarget.scrollHeight > e.currentTarget.clientHeight;
      const atTop = e.currentTarget.scrollTop === 0;
      const atBottom =
        e.currentTarget.scrollHeight ===
        e.currentTarget.scrollTop + e.currentTarget.clientHeight;

      if (
        isScrollable &&
        !(atTop && e.deltaY < 0) &&
        !(atBottom && e.deltaY > 0)
      ) {
        e.stopPropagation();
      }
    };

    const handleMarkerClick = (office) => {
      if (isMobile.value) {
        if (clickedMarker.value === office.id) {
          if (office.link) {
            window.open(office.link, "_blank");
          }
          clickedMarker.value = null;
          activeOffice.value = null;
        } else {
          clickedMarker.value = office.id;
          activeOffice.value = office.id;
          if (map.value && office.coordinates) {
            map.value.setLocation({
              center: office.coordinates,
              duration: 400,
              zoom: 14,
            });
          }
        }
      } else {
        if (office.link) {
          window.open(office.link, "_blank");
        }
        activeOffice.value = office.id;
        clickedMarker.value = office.id;
      }
    };

    const showZoomOverlay = () => {
      overlay.value = true;

      timeout = setTimeout(() => {
        overlay.value = false;
      }, 1500);
    };

    const wheelHandler = (e) => {
      if (e.ctrlKey) {
        overlay.value = false;
      } else {
        e.stopPropagation();
        clearTimeout(timeout);
        showZoomOverlay();
      }
    };

    const touchHandler = (e) => {
      if (!isMapTouchActive.value) {
        clearTimeout(timeout);
        showZoomOverlay();
      }
    };

    const mobileTouchActivate = () => {
      isMapTouchActive.value = !isMapTouchActive.value;
    };

    return {
      map,
      showSidebar,
      activeOffice,
      hoveredOffice,
      offices,
      mapLocation,
      handleOfficeClick,
      handleTouchMove,
      tabs,
      getPhoneClass,
      getPhoneForOffice,
      handleMarkerClick,
      overlay,
      wheelHandler,
      clickedMarker,
      isMobile,
      isMapTouchActive,
      touchHandler,
      mobileTouchActivate,
    };
  },
};
</script>

<style scoped>
.control-buttons {
  display: none;
}

.custom-map-container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 640px;
}

.custom-map-sidebar-header {
  position: absolute;
  z-index: 20;
  width: calc(442px - 15px);
  padding: 30px;
  background: white;
}

.mobile-sidebar-header {
  display: none;
}

.custom-map-sidebar-header__title {
  margin: 0;
  color: #ff0020;
  font-weight: 500;
  font-size: 16px;
}

.mobile-sidebar-header__title {
  margin: 0;
  color: #ff0020;
  font-weight: 500;
  font-size: 16px;
}

.custom-map-toggle-button {
  position: absolute;
  top: 20px;
  left: 455px;
  z-index: 20;
  gap: 8px;
  padding: 0;
  border: none;
  border-radius: 10px;
  transition: background-color 0.3s ease;
}

.custom-map-toggle-button:hover .toggle-icon rect {
  fill: #cc0019;
}

.custom-map-sidebar-header__toggle svg {
  transition: transform 0.3s ease;
}

.custom-map-sidebar-header__toggle svg.rotate-180 {
  transform: rotate(180deg);
}

.custom-map-sidebar {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 442px;
  height: 100%;
  padding-top: 80px;
  background-color: #fff;
  box-shadow: 2px 0 8px rgb(0 0 0 / 0.1);
  transition: transform 0.3s ease;
  transform: translateX(-100%);
}

.custom-map-sidebar.is-visible {
  overflow-y: auto;
  transform: translateX(0);
}

.custom-map-sidebar__list {
  height: calc(100% - 20px);
  padding: 10px 0;
}

.custom-map-sidebar__item {
  margin-bottom: 15px;
  padding: 30px;
  border: 1px solid #eee;
  cursor: pointer;
  transition: all 0.2s;
}

.custom-map-sidebar__item:hover {
  background-color: #f8f8f8;
}

.custom-map-sidebar__item.is-active {
  background-color: #f0f0f0;
}

.custom-map-sidebar::-webkit-scrollbar {
  width: 16px;
  background-color: #fff;
}

.custom-map-sidebar::-webkit-scrollbar-track {
  border-radius: 0;
  background: #fff;
}

.custom-map-sidebar::-webkit-scrollbar-thumb {
  border: 3px solid #fff;
  background: #ff0020;
}

.custom-map-sidebar::-webkit-scrollbar-thumb:hover {
  background: #cc0019;
}

.custom-map-sidebar::-webkit-scrollbar-button:vertical:start:decrement {
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='%23FF0020'%3E%3Cpath d='M7 14l5-5 5 5z'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
}

.custom-map-sidebar::-webkit-scrollbar-button:vertical:end:increment {
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='%23FF0020'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
}

.custom-map-main {
  position: relative;
  flex: 1;
}

.custom-map-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.office-marker {
  position: relative;
  z-index: 1;
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background: #ff0020;
  box-shadow: 0 2px 4px rgb(0 0 0 / 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  transform: translate(-50%, -100%);
}

.office-marker__title {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-bottom: 6px;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: #ff0020;
  color: #fff;
  box-shadow: 0 4px 6px rgb(0 0 0 / 0.1);
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  transform: translate(-50%);
}

.office-marker__image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.office-marker--hover,
.office-marker:active {
  z-index: 1000;
  background: #ff4d4d;
  transform: translate(-50%, -100%) scale(1.2);
}

.office-card__title {
  margin: 0 0 22px;
  color: #291f1f;
  font-weight: 500;
  font-size: 24px;
}

.office-card__address,
.office-card__phone {
  color: #291f1f;
  font-weight: 400;
}

p {
  margin: 0 !important;
}

.comagic_phone {
  color: #ff0020;
  font-weight: 400;
  text-decoration: underline;
}

.toggle-message {
  position: absolute;
  top: 20px;
  left: 490px;
  z-index: 20;
  display: block;
  gap: 8px;
  padding: 5px 8px;
  border-radius: 4px;
  background: #ff0020;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.control-buttons__content {
  display: flex;
  gap: 10px;
  align-items: center;
}

.control-buttons__list {
  padding: 27px 40px;
  border: 1px solid #e6e6e8;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  background: #fff;
  color: #ff0020;
  font-weight: 600;
  font-size: 14px;
}

.control-buttons__list_active {
  background: #ff0020;
  color: #fff;
}

.control-buttons__list .svg-icon {
  fill: #ff0020;
}

.control-buttons__list_active .svg-icon {
  fill: #fff;
}

.control-buttons__map {
  padding: 27px 40px;
  border: 1px solid #e6e6e8;
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
  background: #fff;
  font-weight: 600;
  font-size: 14px;
}

.control-buttons__map_active {
  background: #ff0020;
  color: #fff;
}

.control-buttons__map .svg-icon {
  fill: #ff0020;
}

.control-buttons__map_active .svg-icon {
  fill: #fff;
}

.map-shade {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgb(255 255 255 / 0.8) 0%,
    rgb(255 255 255 / 0) 2%,
    rgb(255 255 255 / 0) 98%,
    rgb(255 255 255 / 0.8) 100%
  );
  pointer-events: none;
}

.map-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 40px;
  background: #ff002066;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.45s ease-in-out,
    -webkit-backdrop-filter 0.45s ease-in-out;
  transition: opacity 0.45s ease-in-out, backdrop-filter 0.45s ease-in-out;
  transition: opacity 0.45s ease-in-out, backdrop-filter 0.45s ease-in-out,
    -webkit-backdrop-filter 0.45s ease-in-out;
  backdrop-filter: blur(10px);
}

.map-overlay.is-active {
  opacity: 1;
  backdrop-filter: blur(7px);
}

.map-overlay.is-touch-active {
  pointer-events: none;
}

.map-overlay.with-sidebar {
  padding-left: 442px;
}

.map-overlay__text {
  color: #fff;
  font-weight: 600;
  font-size: 40px;
  text-align: center;
}

.map-overlay__text.map-overlay__text_mobile {
  display: none;
}

.btn {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: none;
  margin: 10px 34px;
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.particle {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: url(~@i/logo-map-root.svg) 95% center / contain no-repeat;
  pointer-events: none;
}

@media (max-width: 768px) {
  .custom-map-container {
    min-height: 500px;
    padding: 24px;
  }

  .control-buttons {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }

  .custom-map-toggle-button {
    display: none;
  }

  .toggle-message {
    display: none;
  }

  .custom-map-sidebar {
    width: 100%;
    padding-top: 0;
  }

  .custom-map-sidebar-header {
    display: none;
  }

  .mobile-sidebar-header {
    display: block;
    padding: 30px;
    background: white;
  }

  .map-overlay {
    pointer-events: auto;
  }

  .map-overlay__text {
    display: none;
  }

  .map-overlay__text.map-overlay__text_mobile {
    display: block;
    width: 45%;
    font-size: 20px;
    text-align: center;
  }

  .btn {
    display: block;
  }

  .particle {
    background-position: 120px;
    background-size: auto 100%;
  }
}

@media (max-width: 575px) {
  .map-overlay__text.map-overlay__text_mobile {
    width: 100%;
  }
}

.office-marker--mobile {
  z-index: 1000;
}

@media (max-width: 768px) {
  .office-marker__title {
    pointer-events: auto;
  }
}
</style>
